import { Inject, Injectable ,ElementRef } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import	{	DOCUMENT	}	from	'@angular/common';
import { environment } from '../../environments/environment' ;
import { CommonFunctionsService } from './commonFunctions.service' ;
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable({
	providedIn: 'root'
  })
export class SeoService {
	/**This is used to prevent memory leaks **/
	private ngUnsubscribe: Subject<void> = new Subject<void>();
	/**This is used to prevent memory leaks **/
	env = environment;
	siteTitle: any = '';
	siteUrl: any = '';
	metaImage: any = {};
	currentURL='';
	data : any ={};
	constructor(
		private meta: Meta, private title: Title,
		@Inject(DOCUMENT)	private	doc	:	any,
		private commonFunctionsService: CommonFunctionsService,
		private elementRef:ElementRef,
		public router: Router,
		
	) {
		this.siteTitle		=	this.env.SITE_TITLE;
		this.siteUrl		=	this.env.SITE_URL;
		this.metaImage		=	this.env.META_IMAGE;
		 
	}

	generateTags = (config: any): void => {

		if (typeof(config.title) !== 'undefined'){
			this.setTitle(config.title, this.siteTitle);
			this.meta.updateTag({ name: 'twitter:title', content: config.title });
			this.meta.updateTag({ property: 'og:title', content: config.title });
		}else{
			this.setTitle('', this.siteTitle);
			this.meta.updateTag({ name: 'twitter:title', content: this.siteTitle });
			this.meta.updateTag({ property: 'og:title', content: this.siteTitle});
		}
		if (typeof(config.description) !== 'undefined'){
			this.meta.updateTag({ name: 'description', content: config.description });
			this.meta.updateTag({ name: 'twitter:description', content: config.description });
			this.meta.updateTag({ property: 'og:description', content: config.description });
		}else{
			this.meta.updateTag({ name: 'description', content: this.env.SITE_DESCRIPTION });
			this.meta.updateTag({ name: 'twitter:description', content: this.env.SITE_DESCRIPTION });
			this.meta.updateTag({ property: 'og:description', content: this.env.SITE_DESCRIPTION });
		}
		if (typeof(config.card) !== 'undefined'){
			this.meta.updateTag({ name: 'twitter:card', content: config.card });
		}else{
			this.meta.updateTag({ name: 'twitter:card', content: 'summary' });
		}
		if (typeof(config.site) !== 'undefined'){
			this.meta.updateTag({ name: 'twitter:site', content: config.site });
			this.meta.updateTag({ property: 'og:site_name', content: config.site });
		}else{
			this.meta.updateTag({ name: 'twitter:site', content: this.siteTitle});
			this.meta.updateTag({ property: 'og:site_name', content: this.siteTitle });
		}
		
		if (typeof(config.keywords) !== 'undefined'){
			this.meta.updateTag({ name: 'keywords', content: config.keywords });
			this.meta.updateTag({ name: 'twitter:keywords', content: config.keywords });
			this.meta.updateTag({ property: 'og:keywords', content: config.keywords });
		}else{
			this.meta.updateTag({ name: 'keywords', content: this.env.SITE_KEYWORDS });
			this.meta.updateTag({ name: 'twitter:keywords', content: this.env.SITE_KEYWORDS });
			this.meta.updateTag({ property: 'og:keywords', content: this.env.SITE_KEYWORDS });
		}
		if (typeof(config.image) !== 'undefined' && config.image != ''){
			this.meta.updateTag({ name: 'twitter:image', content: config.image });
			this.meta.updateTag({ property: 'og:image', content: config.image });
		}else{
			this.meta.updateTag({ name: 'twitter:image', content: this.env.SITE_URL_WITHOUT_SLASH + this.env.SITE_IMAGE_URL + 'logo.png'});
			this.meta.updateTag({ property: 'og:image', content: this.env.SITE_URL_WITHOUT_SLASH + this.env.SITE_IMAGE_URL + 'logo.png' });
		}
		if (typeof(config.type) !== 'undefined'){
			this.meta.updateTag({ property: 'og:type', content: config.type });
		}else{
			this.meta.updateTag({ property: 'og:type', content: 'Website' });
		}
		this.meta.updateTag({ name : 'robots', content:'index,follow' });

		this.createLinkForCanonicalURL();
		if (typeof(config.seoScritpt) !== 'undefined'){
			let dynamicScript = document.createElement("script");
			dynamicScript.type = "application/ld+json";
			dynamicScript.text = config.seoScritpt;
			this.doc.head.appendChild(dynamicScript);
		}

		
		
		
	}

	createLinkForCanonicalURL()	{
		
		let	currentPage	=	this.doc.URL;
		if(currentPage.indexOf('http') != -1 && currentPage.indexOf('https') == -1){
			currentPage = currentPage.replace('http','https');
		}
		let canonical = this.doc.querySelector("link[rel='canonical']");
		if(canonical != null){
			this.doc.querySelector("link[rel='canonical']").setAttribute('href',	currentPage);
		}else{
			let	link	:	HTMLLinkElement	=	this.doc.createElement('link');
			link.setAttribute('rel',	'canonical');

			this.doc.head.appendChild(link);
			link.setAttribute('href',	currentPage);
		}
		
		this.meta.updateTag({ property: 'og:url', content: currentPage });
	}

	// Function to set page title
	setTitle = ( newTitle: string, siteTitle: string): void => {
		if ( newTitle !== ''){
			//this.title.setTitle(newTitle + ' | ' + siteTitle);
			this.title.setTitle(newTitle);
		}else{
			this.title.setTitle(siteTitle);
		}
	}

	// Function to update loggedin user details
	updateGlobalSeoData = (config: any): void => {
		this.commonFunctionsService.getGlobalSettings().pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
			
			if (response.status === this.env.SUCCESS_STATUS) {
				let seoConfig: any = {}
				if(config.title){
					seoConfig['title'] = response.result[config.title];
				}
				if(config.description){
					seoConfig['description'] = response.result[config.description];
				}
				/**This funcion used to generating seo tag */
				if(config.page){
					seoConfig['image'] = this.metaImage[config.page]
				}

				if(config.seoScritpt){
					seoConfig['seoScritpt'] = config.seoScritpt;
				}
				this.generateTags(seoConfig);
			}
		});
		
	}

    // Function to script Tags Seo Json
	scriptTagsSeoJson = (data: any): void => {
	
		let dynamicScript = document.createElement("script");
		dynamicScript.type = "application/ld+json";
		dynamicScript.text = data;
	    this.doc.head.appendChild(dynamicScript);
	}

}
